import { Injectable } from '@angular/core';
import { RequestData } from 'src/app/common/models/request-data.model';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
@Injectable({
  providedIn: 'root'
})
export class CustomMenuService {

  constructor(private http: HttpClient) { }

  getCustomMenuList(): Observable<any> {
    return this.http.post(environment.baseUrl + '/custom-menu/get', "");
  }
    update(data: any): Observable<any> {
    return this.http.post(environment.baseUrl + '/custom-menu/update', data);
  }
}